import { render, staticRenderFns } from "./ProcessRelational.vue?vue&type=template&id=3a123bca&scoped=true"
import script from "./ProcessRelational.vue?vue&type=script&lang=js"
export * from "./ProcessRelational.vue?vue&type=script&lang=js"
import style0 from "./ProcessRelational.vue?vue&type=style&index=0&id=3a123bca&prod&lang=scss"
import style1 from "./ProcessRelational.vue?vue&type=style&index=1&id=3a123bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a123bca",
  null
  
)

export default component.exports